export default __webpack_public_path__ + "static/media/johnsonHome.dc84ee4c.webp";